<template>
  <div>
    <div class="mb15" v-for="(item, index) in materials" :key="item._id">
        <SmailTitle @on-delete="handleDelete(index)" @on-prev="handleSortPrev(index)" @on-next="handleSortNext(index)" :index="index" :len="materials.length" v-if="item.mediaType === 4" v-model="item.content"></SmailTitle>
        <Describe @on-delete="handleDelete(index)" @on-prev="handleSortPrev(index)" @on-next="handleSortNext(index)" :index="index" :len="materials.length" v-if="item.mediaType === 3" v-model="item.content"></Describe>
        <VideoOrImage @on-delete="handleDelete(index)" @on-prev="handleSortPrev(index)" @on-next="handleSortNext(index)" :index="index" :len="materials.length" v-if="item.mediaType === 1 || item.mediaType === 2">
          <Media :show-close="false" :videoUrl="item.videoUrl" :urls="urls" :mediaType="item.mediaType" :cover="item.cover"></Media>
        </VideoOrImage>
    </div>
  </div>
</template>

<script>
import SmailTitle from "@/components/SmailTitle";
import Describe from "@/components/Describe";
import VideoOrImage from "@/components/VideoOrImage";

import Media from "@/components/Media";
export default {
  components: { SmailTitle, Describe, VideoOrImage, Media },
  props: {
    materials: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    urls() {
      return this.materials.filter(item=> item.mediaType === 2 || item.mediaType === 1).map(item => item.cover)
    }
  },
  methods: {
    handleDelete(index) {
      this.$emit('on-delete', index)
    },
    handleSortPrev(index) {
      this.$emit('on-prev', index)
    },
    handleSortNext(index) {
      this.$emit('on-next', index)
    }
  }
};
</script>

<style lang="scss" scoped>
.mb15{
  margin-bottom: 15px;
}
.cover {
  position: relative;
  width: 100%;
  .cover-img {
    width: 100%;
    border-radius: 2px;
  }
}
</style>